import React from 'react';

import { changeSelectedSlotState } from '@r1-frontend/service-engineer-visit/actions';
import NotAvailableTimePopup from '@r1-frontend/service-engineer-visit/components/NotAvailableTimePopup';
import { useContextDispatch, useContextSelector } from '@r1-frontend/service-engineer-visit/hooks';
import notAvailableTimePopupIsOpen from '@r1-frontend/service-engineer-visit/selectors/notAvailableTimePopupIsOpen';

type TNotAvailableTimePopupContainerProps = {
    title?: string,
    buttonText?: string,
}

const NotAvailableTimePopupContainer = ({ title, buttonText }: TNotAvailableTimePopupContainerProps): JSX.Element => {
    const dispatch = useContextDispatch();
    const { isOpen } = useContextSelector(state => ({
        isOpen: notAvailableTimePopupIsOpen(state),
    }));

    const handleClosePopup = () => {
        dispatch(changeSelectedSlotState(null));
    };

    return (
        <NotAvailableTimePopup
            isOpen={isOpen}
            handleClosePopup={handleClosePopup}
            title={title}
            buttonText={buttonText}
        />
    );
};

export default NotAvailableTimePopupContainer;
